import React, { createContext, useState, useContext, useEffect } from 'react';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    const getSettings = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/settings/get`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('token')
                }
            });
            
            if (!response.ok) {
                throw new Error('Failed to fetch settings');
            }
            
            const data = await response.json();
            if (data) {
                setSettings(data);
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
            // Set default settings if fetch fails
            setSettings({
                productPrice: 400,
                slotPrices: {
                    morning: 400,
                    afternoon: 400,
                    evening: 400,
                    night: 400
                },
                autoApplyCoupons: {
                    oneItem: { enabled: false, name: '', value: 0 },
                    twoItems: { enabled: true, name: 'DOUBLESHOT', value: 100 },
                    threeItems: { enabled: true, name: 'TRIPLEDEAL', value: 200 },
                    fourItems: { enabled: true, name: 'QUADBUNDLE', value: 300 }
                },
                twilightCoupon: { enabled: true, name: 'TWILIGHT', value: 100 },
                disableAfternoonEveningCoupon: false,
                hideBookSeatNowButton: false,
                hideRenewBookingButton: false,
                locationColors: {}
            });
        } finally {
            setLoading(false);
        }
    };

    const updateSettings = async (newSettings) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/settings/update`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('token')
                },
                body: JSON.stringify(newSettings)
            });
            const data = await response.json().catch(() => null);
            if (!response.ok) {
                console.error('Settings update failed', data);
                return false;
            }
            if (data) {
                setSettings(data);
                await getSettings();
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error updating settings:', error);
            return false;
        }
    };

    useEffect(() => {
        getSettings(); // Fetch settings for all users to support auto-apply coupons
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, loading, updateSettings, getSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};

export default SettingsContext; 